import React from 'react';
import { settingsFunctions } from '../../../../functions/settings';
import styles from './ButtonPreview.module.css'

const ButtonPreview = (props) => {
    const { reference, data, label, icon, profile_theme } = props;
    const { getSocialUserHandle } = settingsFunctions;

    getSocialUserHandle(reference, data);

    return (
        <div className={styles.container}>
            <div className={styles.outside} style={{background: profile_theme.btm_card_color}}>
                <div className={styles.btn} style={icon !== '' ? {background: 'linear-gradient(to right, transparent 8%, ' + profile_theme.btn_color + ' 20%, ' + profile_theme.btn_color + ')'} : {background: profile_theme.btn_color}} >
                    <div className={styles.icon}>
                        {icon && <i className={icon} style={{background: profile_theme.icon_color}}></i>}
                    </div>
                    <div className={styles.link} style={{fontFamily: profile_theme.font}}> 
                        <div className={styles.linkName} style={{color: profile_theme.btm_text_color}}>{label === undefined || label === '' ? reference === 'phone' ? "Work Phone" : reference.charAt(0).toUpperCase() + reference.slice(1) : label}</div>
                    </div>
                    <div className={styles.arrow}>
                        <i className='fa fa-arrow-right' style={{color: profile_theme.btm_text_color}}></i>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ButtonPreview;